import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { MatTooltip } from '@angular/material/tooltip'
import { MatIcon } from '@angular/material/icon'

@Component({
  selector: 'app-state-icon',
  templateUrl: './state-icon.component.html',
  styleUrls: ['./state-icon.component.scss'],
  imports: [MatIcon, MatTooltip],
})
export class StateIconComponent<T> {
  /**
   * Needs to serialize to string
   */
  @Input() state: T

  @Input() mapStateToIcon: (state: T) => string
}
